import ScanPlate from './ScanPlate';

export default ScanPlate;
